import { render, staticRenderFns } from "./SystemComponentTable.vue?vue&type=template&id=0f7c1e4c&"
import script from "./SystemComponentTable.vue?vue&type=script&lang=js&"
export * from "./SystemComponentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports